import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SurveyPage } from './pages/SurveyPage';
import { PreviewPage } from './pages/PreviewPage';
import { QualityUI } from './components/ui';

export function App() {
  return (
    <BrowserRouter>
      {/* Quality enforcement UI (warnings + termination overlay) */}
      <QualityUI />
      <Routes>
        {/* Preview route (no session required) */}
        <Route path="/preview/:surveyId" element={<PreviewPage />} />

        {/* Main survey route */}
        <Route path="/s/:surveyId" element={<SurveyPage />} />

        {/* Redirect root to a helpful message */}
        <Route
          path="/"
          element={
            <div className="flex min-h-screen items-center justify-center bg-gray-50">
              <div className="text-center">
                <h1 className="text-2xl font-semibold text-gray-900">Survey Player</h1>
                <p className="mt-2 text-gray-600">
                  Please use a valid survey link to access a survey.
                </p>
              </div>
            </div>
          }
        />

        {/* 404 */}
        <Route
          path="*"
          element={
            <div className="flex min-h-screen items-center justify-center bg-gray-50">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900">404</h1>
                <p className="mt-2 text-gray-600">Page not found</p>
              </div>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
